import type { ReactNode } from 'react';

export type VideoBoxLayoutProps = {
  contentTemplate?: ReactNode;
  actionsTemplate?: ReactNode;
};

export function VideoBoxLayout({ contentTemplate, actionsTemplate }: VideoBoxLayoutProps) {
  return (
    <>
      <div className="video-box__content">{contentTemplate}</div>
      <div className="video-box__bottom-action-panel">{actionsTemplate}</div>
    </>
  );
}
